/* eslint-env browser */
import { combineReducers } from 'redux';
import cookieUtils from 'angieslist-app-platform/lib/common/utils/cookieUtils';
import { AsyncRequest } from 'angieslist-app-platform';
import accountSyncActionKeys from './accountSyncActionKeys';

export default combineReducers({
  createAccount: AsyncRequest.createReducer(accountSyncActionKeys.CREATE_ACCOUNT),
  matches: AsyncRequest.createReducer(accountSyncActionKeys.GET_USER_MATCHES),
  linkBusiness: AsyncRequest.createReducer(accountSyncActionKeys.LINK_BUSINESS),
  linkAccounts: AsyncRequest.createReducer(accountSyncActionKeys.LINK_ACCOUNTS, {
    [accountSyncActionKeys.LINK_ACCOUNTS_SUCCESS]: (state, action) => {
      cookieUtils.deleteCookie('entityId');
      cookieUtils.deleteCookie('entityHash');
      return AsyncRequest.setSuccess(state, action.payload.status);
    },
  }),
});



// WEBPACK FOOTER //
// ./src/modules/sync/common/accountSyncReducer.js